import { render } from "./SwitchMobile.vue?vue&type=template&id=6ba77ae4&scoped=true"
import script from "./SwitchMobile.vue?vue&type=script&lang=js"
export * from "./SwitchMobile.vue?vue&type=script&lang=js"

import "./SwitchMobile.vue?vue&type=style&index=0&id=6ba77ae4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba77ae4"]])

export default __exports__